import { Injectable } from '@angular/core';

@Injectable()
export class PasswordResetUrlService {
	constructor() {}

	get domainName(): string {
		return '';
	}

	get passwordResetURL() {
		return '';
	}
}
